<template>
  <page-outline :title="$t('administration.company_edit')">
    <template slot="pageContent">
      <b-row class="pb-3 no-gutters">
        <back-button :returnUrl="returnUrl"></back-button>
      </b-row>
      <spinner v-if="activateSpinner"></spinner>
      <form-accordion v-if="activateSpinner === false" :isTitleUpperCase="false" :title="$t('common.busnss')">
        <b-row>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="identifier" isMandatory
              :inputLabel="$t('administration.company_id')" :placeholderValue="CompaniesList[0].identifier">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="name" isMandatory
              :inputLabel="$t('administration.name')" :placeholderValue="CompaniesList[0].name">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input isMandatory
              :inputType="'listeSelect'" :inputLabel="$t('administration.active_enable')" :placeholderValue="CompaniesList[0].active">
              <select class="form-control" id="sel4" v-model="active">
                <option value="0"> {{ $t('administration.no') }} </option>
                <option value="1"> {{ $t('administration.in_prgrss') }} </option>
                <option value="2"> {{ $t('administration.yes') }} </option>
              </select>
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="email_reference" isMandatory
              :inputLabel="$t('administration.company_email')" :placeholderValue="CompaniesList[0].email_reference">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row class="justify-content-end form-group no-gutters" v-if="canCompanyEdit">
          <b-button variant="primary"
            @click="changeCompany()">
            <i class="fa-light fa-save"></i>
            <span>{{ $t('common.sve') }}</span>
          </b-button>
        </b-row>
      </form-accordion>
      <br>
      <form-accordion v-if="activateSpinner === false" :isTitleUpperCase="false" :title="$t('administration.company_users')">
        <b-table v-if="CompaniesList.length > 0" hover 
          :fields="userFields"
          :items="CompaniesList[0].users"
          :selectable="CompaniesList[0].users.length > 0"
          empty-text="Pas de résultat"
          @row-selected="seeUserDetails">
            <template #cell(edit)="data">
              <span class="text-center d-inline-block py-3 w-100" @click="activateUserEdit($event, data.value)"><i class="fa-light fa-pencil"></i></span>
            </template>
            <template #cell(delete)="data">
              <span class="text-center d-inline-block py-3 w-100" @click="activateUserDelete($event, data.value)"><i class="fa-light fa-trash"></i></span>
            </template>
        </b-table>
        <!--ANCIENNE TABLE DRO 17/08/2023
        <table class="table">
          <thead>
            <th class="text-center">
              {{ $t('administration.login') }}
            </th>
            <th v-if="canUserEdit" class="text-center w-10" >
              {{ $t('administration.edit') }}
            </th>
            <th v-if="canUserDelete" class="text-center w-10" >
              {{ $t('administration.del') }}
            </th>
          </thead>
          <tbody>
            <template v-if="CompaniesList.length > 0">
              <tr v-for="result in CompaniesList[0].users" :key="result.id"
                class="boxRequest">
                <~~! <td>{{result}}</td> ~~>
                <td class="text-center" :title="result.login" @click="activateUserDetail(result.id_user_account)">{{ result.login }}</td>
                <td v-if="canUserEdit" class="text-center" :title="$t('administration.edit')"
                @click="activateUserEdit(result.id_user_account)">
                  <i class="fa-light fa-pencil"></i>
                </td>
                <td v-if="canUserDelete" class="text-center" :title="$t('administration.del')"
                @click="activateUserDelete(result.id_user_account)">
                  <i class="fa-light fa-trash"></i>
                </td>
              </tr>
            </template>
            <tr v-else>
              <td colspan="6" class="noResult">
                {{ $t('common.no_result') }}
              </td>
            </tr>
          </tbody>
        </table>-->
        <b-row class="justify-content-end no-gutters" v-if="canAddUser">
          <b-button variant="primary"
            @click="addUser">
            <i class="fa-light fa-plus"></i>
            <span>{{$t('administration.user_add')}}</span>
          </b-button>
        </b-row>
      </form-accordion>
      <br>
      <form-accordion v-if="activateSpinner === false" :isTitleUpperCase="false" :title="$t('administration.company_prfls')">
        <b-table v-if="CompaniesList.length > 0" hover
          :fields="profileFields"
          :items="CompaniesList[0].profiles"
          :selectable="CompaniesList[0].profiles.length > 0"
          :key="resetProfileTable"
          empty-text="Pas de résultat"
          @row-selected="seeProfileDetails">
            <template #cell(edit)="data">
              <span class="text-center d-inline-block py-3 w-100" @click="activateProfilEdit($event, data.value)"><i class="fa-light fa-pencil"></i></span>
            </template>
            <template #cell(delete)="data">
              <span class="text-center d-inline-block py-3 w-100" @click="activateProfilDelete($event, data.value)"><i class="fa-light fa-trash"></i></span>
            </template>
        </b-table>
        <!--ANCIENNE TABLE DRO 17/08/2023
        <table class="table">
          <thead>
            <th class="text-center">
              {{ $t('administration.label') }}
              <i class="fa"></i>
            </th>
            <th v-if="canProfileEdit" class="text-center w-10">
                {{ $t('administration.edit') }}
            </th>
            <th v-if="canProfileDelete" class="text-center w-10">
                {{ $t('administration.del') }}
            </th>
          </thead>
          <tbody>
            <template v-if="CompaniesList.length > 0">
              <tr v-for="result in CompaniesList[0].profiles"
                class="boxRequest">
                <td class="text-center" :title="result.libelle" @click="activateProfilDetail(result.id_rights_profile)">{{ result.libelle }}</td>
                <td v-if="canProfileEdit" class="text-center" :title="$t('administration.edit')"
                @click="activateProfilEdit(result.id_rights_profile)">
                  <i class="fa-light fa-pencil"></i>
                </td>
                <td v-if="canProfileDelete" class="text-center" :title="$t('administration.del')"
                @click="activateProfilDelete(result.id_rights_profile)">
                  <i class="fa-light fa-trash"></i>
                </td>
              </tr>
            </template>
            <tr v-else>
              <td colspan="6" class="noResult">
                {{ $t('common.no_result') }}
              </td>
            </tr>
          </tbody>
        </table>-->
        <b-row class="justify-content-end no-gutters" v-if="canAddProfil">
          <b-button variant="primary"
          @click="addProfil">
            <i class="fa-light fa-plus"></i>
            <span>{{$t('administration.profile_add')}}</span>
          </b-button>
        </b-row>
      </form-accordion>
      <br>
      <form-accordion v-if="activateSpinner === false" :isTitleUpperCase="false" :title="$t('administration.company_rights')">
        <b-table v-if="CompaniesList.length > 0"
          :items="rights"
          :fields="rightsFields"
          :key="resetProfileTable">
          <template #cell(right)="data">
          <span>{{ $t('rights.db_rights.' + data.value) }}</span>
          </template>
          <template #cell(delete)="data">
            <span class="text-center d-inline-block py-3 w-100" @click="deleteRight($event, data.value)"><i class="fa-light fa-trash"></i></span>
          </template>
        </b-table>
        <!--
        <table class="table text-center">
          <thead>
            <th width="100%">
              {{ $t('administration.right_list') }}
              <i class="fa"></i>
            </th>
            <th>{{ $t('administration.del') }}</th>
          </thead>
          <tbody>
            <template v-if="CompaniesList.length > 0">
              <tr v-for="result in CompaniesList[0].rights"
                class="boxRequest">
                <td :title="$t('rights.db_rights.' + result) === ('rights.db_rights.' + result) ? result : $t('rights.db_rights.' + result)">
                  {{ $t('rights.db_rights.' + result) === ('rights.db_rights.' + result) ? result : $t('rights.db_rights.' + result) }}
                </td>
                <~~! DDE 03/11/2022: l'utilisateur qui a un profil admin peut
                  supprimer les droits commons des autres mais pas les siens ~~>
                  <~~! condition a modifier ~~>
                <td v-if="result !== 'common' && canDeleteRight" @click="deleteRight(result)">
                  <i class="fa-light fa-trash" ></i>
                </td>
                <td v-else></td>
              </tr>
            </template>
            <tr v-else>
              <td colspan="6" class="noResult">
                {{ $t('common.no_result') }}
              </td>
            </tr>
          </tbody>
        </table> 
        -->
        <b-row class="justify-content-end no-gutters" v-if="canAddRights">
          <b-button variant="primary"
          @click="addRight">
            <i class="fa-light fa-plus"></i>
            <span>{{$t('administration.right_add')}}</span>
          </b-button>
        </b-row>
      </form-accordion>
    </template>
  </page-outline>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'

import {loadPage} from '@/helpers/routing'
// import {validateAccountFormat, validateEmail, validateSIREN, validatePhoneNumber} from '@/helpers/validator'

export default {
  name: 'EditUserCompany',
  components: {
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'back-button': backButton,
    'spinner': Spinner
  },
  props: ['idCompany'],
  computed: {
    canAddUser () {
      return this.$engine.rights.rightIs('usercompany_ajouter', true) || this.$engine.rights.rightIs('usercompany_ajouter_admin', true)
    },
    canAddProfil () {
      return this.$engine.rights.rightIs('profilcompany_ajouter', true)
    },
    canAddRights () {
      return this.$engine.rights.rightIs('company_editer', true)
    },
    canCompanyEdit () {
      return this.$engine.rights.rightIs('company_editer', true)
    },
    canDeleteRight () {
      return this.$engine.rights.rightIs('company_editer', true)
    },
    canProfileConsult () {
      return this.$engine.rights.rightIs('profilcompany_consulter', true)
    },
    canProfileEdit () {
      return this.$engine.rights.rightIs('profilcompany_editer', true)
    },
    canProfileDelete () {
      return this.$engine.rights.rightIs('profilcompany_supprimer', true)
    },
    canUserConsult () {
      return this.$engine.rights.rightIs('usercompany_consulter', true) || this.$engine.rights.rightIs('usercompany_consulter_admin', true)
    },
    canUserEdit () {
      return this.$engine.rights.rightIs('usercompany_editer', true) || this.$engine.rights.rightIs('usercompany_editer_admin', true)
    },
    canUserDelete () {
      return this.$engine.rights.rightIs('usercompany_supprimer', true) || this.$engine.rights.rightIs('usercompany_supprimer_admin', true)
    }
  },
  data () {
    return {
      acc: {},
      activateSpinner: false,
      active: '',
      CompaniesList: [],
      email_reference: '',
      identifier: '',
      name: '',
      profileFields: [],
      resetProfileTable: false,
      returnUrl: '/company/',
      rights: [],
      rightsFields: [],
      userFields: []
    }
  },
  created () {
    this.$e
    this.profileFields = [
      {key: 'libelle', label: this.$t('administration.label'), class:'text-center', tdClass: 'py-3'}
    ]
    this.rightsFields = [
      {key: 'right', label: this.$t('administration.right_list'), class:'text-center', tdClass: 'py-3'}
    ]
    this.userFields = [
      {key: 'login', label: this.$t('administration.login'), class:'text-center', tdClass: 'py-3'}
    ]
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Modification de l\'entreprise',
      returnUrl: ''
    })
    this.$engine.settings.set({msgDirection: this.direction})
    // this.$bus.$off('refresh-cache-contacts')
    this.atStart(this.idCompany) // modif a check
    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    // this.atStart(false)

    this.filterTypeGet = this.filterType
    if(this.canProfileDelete) {
      this.profileFields.push({ key: 'delete', label: this.$t('common.del_label'), thClass: 'text-center table-condensed-ipad w-10', tdClass: 'p-0' })
    }
    if(this.canProfileEdit) {
      this.profileFields.push({ key: 'edit', label: this.$t('rights.edit'), thClass: 'text-center table-condensed-ipad w-10', tdClass: 'p-0' })
    }
    if(this.canDeleteRight) {
      this.rightsFields.push({ key: 'delete', label: this.$t('common.del_label'), thClass: 'text-center table-condensed-ipad w-10', tdClass: 'p-0' })
    }
    if(this.canUserDelete) {
      this.userFields.push({ key: 'delete', label: this.$t('common.del_label'), thClass: 'text-center table-condensed-ipad w-10', tdClass: 'p-0' })
    }
    if(this.canUserEdit) {
      this.userFields.push({ key: 'edit', label: this.$t('rights.edit'), thClass: 'text-center table-condensed-ipad w-10', tdClass: 'p-0' })
    }
    this.$bus.$emit('right-panel-set-feature', 'filter-messages')
  },
  methods: {
    atStart (val = 1) {
      let that = this
      that.pageCounter = 0
      that.activateSpinner = true
      that.CompaniesList = []
      let filterConditions = that.$engine.company.getConditionObject()
      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      that.$engine.company.getCompany(
        val,
        10,
        1,
        filterConditions
      ).then(resp => {
        let requests = {}
        if (resp.data) {
          resp.data.company.idCompany = val
          resp.data.company.identifier = resp.data.company.account.identifier
          resp.data.company.name = resp.data.company.account.name
          resp.data.company.email_reference = resp.data.company.account.email_reference
          resp.data.company.active = resp.data.company.account.active
          resp.data.company.rights.forEach((item, index) => {
            that.rights.push({right: item, delete: item})
          })
          resp.data.company.profiles.forEach(item => {
            item.id_rights_profile = item.id_rights_profile
            item.libelle = item.libelle
            item.delete = item.id_rights_profile
            item.edit = item.id_rights_profile
          }) 
          resp.data.company.users.forEach(item => {
            item.id_user_account = item.id_user_account
            item.login = item.login
            item.delete = item.id_user_account
            item.edit = item.id_user_account
          })
          requests = resp.data.company
          that.CompaniesList.push(requests)
          this.updateModel()
          that.$f7.pullToRefreshDone()
          that.$bus.$emit('refresh-cache-paging-template', this.paginationObject)
        }
        that.activateSpinner = false
      }).catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    updateModel () {
      this.identifier = this.CompaniesList[0].identifier
      this.active = this.CompaniesList[0].active
      this.name = this.CompaniesList[0].name
      this.email_reference = this.CompaniesList[0].email_reference
    },
    activateUserDetail (id) {
      let that = this
      if(this.canUserConsult) {
        loadPage(that, {url: '/detailusercompany/' + id + '/' + this.idCompany})
      } else {
        return
      }
    },
    activateUserEdit ($e, id) {
      let that = this
      $e.stopPropagation()
      this.$engine.company.profiles = that.CompaniesList[0].profiles
      loadPage(that, {url: '/editusercompany/' + id + '/' + this.idCompany})
    },
    activateUserDelete ($e, ressource) {
      let that = this
      $e.stopPropagation()
      this.$f7.modal({
        title: this.$i18n.t('administration.del_user_qt'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              that.$engine.usercompany.deleteUser(ressource)
              .then(resp => {
                that.$f7.alert('', that.$t('administration.del_user'))
                that.atStart(Number(that.CompaniesList[0].idCompany))
              }).catch(e => {
                errorMessageAlert(e, that)
                that.$f7.modal({
                  title: that.$i18n.t('administration.del_error'),
                  buttons: [
                    {
                      text: 'OK',
                      onClick: function () {
                        return
                      }
                    }
                  ]
                })
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    activateProfilDetail (id) {
      let that = this
      if(this.canProfileConsult) {
        loadPage(that, {url: '/detailprofilcompany/' + id + '/' + this.idCompany})
      } else {
        return
      }
    },
    activateProfilDelete ($e, ressource) {
      let that = this
      $e.stopPropagation()
      this.$f7.modal({
        title: this.$i18n.t('administration.del_profile_qt'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              that.$engine.profilcompany.deleteProfil(ressource)
              .then(resp => {
                that.$f7.alert('', that.$t('administration.del_profile'))
                loadPage(that, {url: '/company/'})
              }).catch(e => {
                if (e.response.data.error === 'id_rights_profile used by a user') {
                  that.$f7.modal({
                    title: that.$i18n.t('administration.unable_del'),
                    buttons: [
                      {
                        text: 'OK',
                        onClick: function () {
                          return
                        }
                      }
                    ]
                  })
                } else {
                  that.$f7.modal({
                    title: that.$i18n.t('administration.del_error'),
                    buttons: [
                      {
                        text: 'OK',
                        onClick: function () {
                          return
                        }
                      }
                    ]
                  })
                }
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    activateProfilEdit ($e, id) {
      let that = this
      $e.stopPropagation()
      this.$engine.company.rightsL = that.CompaniesList[0].rights
      loadPage(that, {url: '/editprofilcompany/' + id + '/' + this.idCompany})
    },
    addProfil () {
      let that = this
      this.$engine.company.rightsL = that.CompaniesList[0].rights
      loadPage(that, {url: '/addprofilcompany/' + this.idCompany})
    },
    addUser () {
      let that = this
      this.$engine.company.profiles = that.CompaniesList[0].profiles
      loadPage(that, {url: '/addusercompany/' + this.idCompany})
    },
    addRight () {
      let that = this
      this.$engine.company.rightsL = that.CompaniesList[0].rights
      loadPage(that, {url: '/addrights/' + this.idCompany})
    },
    deleteRight ($e, right) {
      let that = this
      $e.stopPropagation()
      // let rights = (this.CompaniesList[0].rights).filter(r => r !== right)
      // console.log('rights', rights)
      this.CompaniesList[0].account.id = this.idCompany
      this.$f7.modal({
        title: this.$i18n.t('administration.del_right_qt'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              that.$f7.showPreloader(that.$t('administration.right_deleting'))
              that.$engine.company.deleteRight(that.idCompany, that.CompaniesList[0].account, that.CompaniesList[0].rights, right)
              .then(resp => {
                if(resp.status === 200)  {  
                  that.$f7.hidePreloader()
                  that.$f7.alert('', that.$t('administration.del_right'))
                  loadPage(that, {url: '/company/'})
                }
                //that.refreshProfileList()
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    changeCompany () {
      let that = this
      that.$f7.showPreloader(that.$t('administration.company_edition'))
      this.$engine.company.editCompany(
        this.idCompany,
        this.identifier,
        this.name,
        this.email_reference,
        this.active,
        this.CompaniesList[0].rights
      ).then(resp => {
        that.$f7.hidePreloader()
        that.$f7.modal({
          title: that.$i18n.t('administration.edit_company'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/company/'})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.$f7.modal({
          title: that.$i18n.t('administration.edit_error'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
      })
    },
    seeProfileDetails (items) {
      this.activateProfilDetail(items[0].id_rights_profile)
      this.resetProfileTable = !this.resetProfileTable
    },
    seeUserDetails (items) {
      this.activateUserDetail(items[0].id_user_account)
    },
  }
}
</script>
